<section
  class="flex flex-col overflow-hidden rounded-xl border border-primary/20 bg-primary-container/40"
>
  <div class="flex flex-wrap items-start gap-4 p-6">
    <span
      class="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-primary text-on-primary"
    >
      <mat-icon>school</mat-icon>
    </span>

    <div class="flex min-w-64 flex-1 flex-col gap-3">
      <div>
        <p class="text-xs font-medium tracking-wide text-on-surface-variant uppercase">
          Š1 · Celosborové školení
        </p>
        <h2 class="mt-1 font-medium text-on-primary-container">{{ trainingTitle }}</h2>
        <p class="mt-1 text-sm leading-relaxed text-on-surface-variant">
          Pro celé pedagogické sbory základních škol, vedení školy, koordinátory ŠVP a předmětové
          týmy. Online nebo prezenčně ve škole, rozsah 8 × 45 min. Cena na vyžádání — školení lze
          hradit z OP JAK – Šablony II v rámci vzdělávání pracovníků ve vzdělávání.
        </p>
      </div>

      <div class="flex flex-col gap-1.5">
        <p
          class="flex items-start gap-2 text-sm leading-relaxed font-medium text-on-primary-container"
        >
          <mat-icon class="!mt-0.5 !h-4 !w-4 shrink-0 !text-base/none text-primary">sell</mat-icon>
          <span>Uživatelé Mapy výuky mají na školení slevu {{ discountPercent }}&nbsp;%.</span>
        </p>
        <p
          class="flex items-start gap-2 text-sm leading-relaxed font-medium text-on-primary-container"
        >
          <mat-icon class="!mt-0.5 !h-4 !w-4 shrink-0 !text-base/none text-primary"
            >savings</mat-icon
          >
          <span>Ze stejných šablon lze hradit i licenci Mapy výuky.</span>
        </p>
      </div>

      <div class="flex flex-wrap items-center gap-2">
        <a matButton="filled" [href]="trainingUrl" target="_blank" rel="noopener">
          <mat-icon>open_in_new</mat-icon>
          Program a objednávka školení
        </a>
        <button
          matButton
          type="button"
          [attr.aria-expanded]="topicsOpen()"
          (click)="toggleTopics()"
        >
          Co se účastníci naučí
          <mat-icon class="transition-transform" [class.rotate-180]="topicsOpen()">
            expand_more
          </mat-icon>
        </button>
      </div>
    </div>

    <button
      type="button"
      matIconButton
      class="shrink-0"
      aria-label="Skrýt"
      title="Skrýt"
      (click)="dismiss()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  @if (topicsOpen()) {
    <ul
      class="flex list-disc flex-col gap-1.5 border-t border-primary/20 bg-surface py-4 pr-6 pl-10 text-sm leading-relaxed text-on-surface-variant"
    >
      @for (topic of topics; track topic) {
        <li>{{ topic }}</li>
      }
    </ul>
  }
</section>
